import pages from './endpoints/page';

const allEndpoints = {
  pages,
};

export default allEndpoints;
